import { ColumnDef } from "types/common/Header";
import HeaderCell from "./BaseHeaderCell";
import { ORDER_BY } from "pages/admin-app/adminapp.constants";

interface Props<T> {
  headers: ColumnDef<T>[];
  sortedKey: string;
  sortedOrder: ORDER_BY;
  onSort: (key: string) => void;
}

const BaseHeader = <T,>({
  headers,
  sortedKey,
  sortedOrder,
  onSort,
}: Props<T>) => {
  const headerCells = headers.map((header) => (
    <HeaderCell
      key={header.sortKey}
      header={header}
      sortedKey={sortedKey}
      sortedOrder={sortedOrder}
      onSort={onSort}
    />
  ));

  return (
    <thead>
      <tr className="table__header-row">{headerCells}</tr>
    </thead>
  );
};

export default BaseHeader;
